export default __webpack_public_path__ + "static/media/support.577d7c1b.jpg";